import { FormattedMessage } from 'react-intl';
import { IconButton } from '@eventbrite/marmalade';
import { Cross as CrossIcon } from '@/components/_shared/Icons';

interface WaitingRoomBannerProps {
  onCloseClick: () => void;
}

export const WaitingRoomBanner = ({ onCloseClick }: WaitingRoomBannerProps) => {
  return (
    <>
      <p>
        <FormattedMessage
          id="Tickets are in high demand. You might be placed in a queue"
          defaultMessage="Tickets are in high demand. You might be placed in a queue"
          description="Waiting room banner prompt text shown when waiting room is activated"
        />
      </p>
      <IconButton icon={<CrossIcon viewBox="0 0 25 25" />} aria-label="Close" onClick={onCloseClick} />
    </>
  );
};
